<template>
  <div style="position: relative;">
    <div id="intro" class="intro" v-html="webinarInfo.intro">

    </div>
<!--    <img class="beauty1" src="../../assets/images/beauty1.png" alt="">-->
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water";
export default {
  name: "Introduction",
  data() {
    return {
      webinarInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("webinarInfo", data => {
        this.webinarInfo = data;
      });
    }
  }
};
</script>

<style scoped>

</style>
